import { I18nComponente } from "@/types/gerais"

export const OTabelaProfissionais18n: I18nComponente = {
  "pt-BR": {
    nome: "nome",
    codigo: "código",
    categoria: "categoria",
    usuariosResponsaveis: "usuários responsáveis",
    pesquisarPorUsuarioResponsavel: "pesquisar por usuário responsável",
    pesquisarPorCodigoDoProfissional: "pesquisar por código do profissional",
    pesquisarPorNomeDoProfissional: "pesquisar por nome do profissional",
    nenhumUsuarioResponsavel: "nenhum usuário responsável",
    selecionarCategoria: "selecionar categoria",
    aplicar: "Aplicar",
    limpar: "Limpar",
    editar: "editar",
    deletar: "deletar",
    arquivar: "arquivar",
    desarquivar: "desarquivar",
    ocorreuUmErro: "Ocorreu um erro",
    naoFoiPossivelRemoverProfissional: "Não foi possível remover o profissional",
  },
  "es-CO": {
    nome: "nombre",
    codigo: "código",
    categoria: "categoría",
    usuariosResponsaveis: "usuarios responsables",
    pesquisarPorUsuarioResponsavel: "buscar por usuario responsable",
    pesquisarPorCodigoDoProfissional: "buscar por código del profesional",
    pesquisarPorNomeDoProfissional: "buscar por nombre del profesional",
    nenhumUsuarioResponsavel: "ningún usuario responsable",
    selecionarCategoria: "seleccionar categoría",
    aplicar: "Aplicar",
    limpar: "Borrar",
    editar: "editar",
    deletar: "borrar",
    arquivar: "archivar",
    desarquivar: "desarchivar",
    ocorreuUmErro: "Ocurrió un error",
    naoFoiPossivelRemoverProfissional: "No fue posible borrar el profesional",
  },
}
